import { Controller } from "@hotwired/stimulus"

// Expand/collapse a round card. The card lives in a <turbo-frame>, so a
// Recompute / Assign action (which redirects and re-renders the frame) would
// otherwise reset the panel to its default-collapsed state. Persist the open
// state per round and restore it on connect so it survives the re-render.
export default class extends Controller {
  static targets = ["panel", "chevron"]
  static values = { id: String }

  connect() {
    if (this.idValue && localStorage.getItem(this.storageKey) === "open")
      this.open()
  }

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.chevronTarget.classList.add("rotate-90")
    if (this.idValue) localStorage.setItem(this.storageKey, "open")
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-90")
    if (this.idValue) localStorage.removeItem(this.storageKey)
  }

  get storageKey() {
    return `round-card:${this.idValue}`
  }
}
